import * as actionTypes from '../actions/actionTypes';

const initialState = {
    products:[],
    pageNumber:1,
    product:null,
    filteredPageNumber:1,
    filteredProducts:[],
};

const getProductsSuccess = (state, action) => {
    const newState= {
        ...state,
        pageNumber: state.pageNumber+1,
        products: [...state.products ,...action.products],
    }
    return newState
};
const getFilteredProductsSuccess = (state, action) => {
    const newState= {
        ...state,
        filteredPageNumber: state.filteredPageNumber+1,
        filteredProducts: [...state.filteredProducts ,...action.filteredProducts],
    }
    return newState
};
const getProductSuccess = (state, action) => {
    const newState= {
        ...state,
        product:{...action.product},
    }
    return newState
};
const productCleanUp = (state, action) => {
    const newState= {
        ...state,
        product: action.product,
    }
    return newState
};

const reset = (state, action) => {
    const newState= {
        ...state,
        products: action.products,
        pageNumber: action.pageNumber
    }
    return newState
};

const resetFilteredProducts = (state, action) => {
    const newState= {
        ...state,
        filteredPageNumber: action.filteredPageNumber,
        filteredProducts: action.filteredProducts,
    }
    return newState
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.GET_PRODUCTS_SUCCESS: return getProductsSuccess( state, action );
        case actionTypes.GET_PRODUCT_SUCCESS: return getProductSuccess( state, action );
        case actionTypes.PRODUCT_CLEAN_UP: return productCleanUp( state, action );
        case actionTypes.RESET:return reset( state, action );
        case actionTypes.RESET_FILTERED_PRODUCTS:return resetFilteredProducts( state, action );
        case actionTypes.GET_FILTERED_PRODUCTS_SUCCESS: return getFilteredProductsSuccess( state, action );
        default: return state;
    }
};

export default reducer;